/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { JobId } from "../../commons/types/JobId";
import { ActorId } from "../../commons/types/ActorId";
import { SpaceId } from "../../commons/types/SpaceId";
import { JobConfig } from "./JobConfig";
export const Job = core.serialization
    .object({
    id: JobId,
    createdBy: ActorId,
    createdAt: core.serialization.date(),
    updatedAt: core.serialization.date(),
    startedAt: core.serialization.date().optional(),
    finishedAt: core.serialization.date().optional(),
    outcomeAcknowledgedAt: core.serialization.date().optional(),
    spaceId: SpaceId.optional(),
})
    .extend(JobConfig);
